module.exports = __webpack_public_path__ + "media/images/icon/icons8-New Document-5a20eab942627825ba6f1f66c5bea150.png";